var map = {
	"./1000-employees.png": 3943,
	"./30-stores.png": 9950,
	"./Joinplan.gif": 8298,
	"./above_banner.jpg": 9968,
	"./android.png": 779,
	"./apple.png": 642,
	"./auth-background.jpeg": 7290,
	"./auth-backgrounds.jpeg": 2619,
	"./auth-backgroundss.jpg": 7939,
	"./auth-backgroundsss.jpg": 5084,
	"./b1.jpg": 9267,
	"./b2.jpg": 9556,
	"./b3.jpg": 3889,
	"./b4.jpg": 9282,
	"./b5.jpg": 991,
	"./bannerVideo.mp4": 646,
	"./bannerVideo2.mp4": 5766,
	"./bannerVideo3.mp4": 9083,
	"./base_prmintmayil1.jpg": 1071,
	"./best-price.png": 3218,
	"./best-quality.png": 5262,
	"./certified-jewellery.png": 1977,
	"./chain.png": 4717,
	"./check_small_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg": 5701,
	"./feature_dot.svg": 1132,
	"./free-shipping.png": 3135,
	"./homeLogin.svg": 1318,
	"./images.jpeg": 6324,
	"./lakshmi_coin.jpg": 9141,
	"./li_calendar.svg": 5316,
	"./life-time-exchange.png": 8666,
	"./limited-company.png": 8114,
	"./menu_icon.svg": 3689,
	"./mobile.svg": 2212,
	"./money-back.png": 720,
	"./owner_image.png": 269,
	"./refund.png": 1810,
	"./secured-retail.png": 3555,
	"./term's and condition.pdf": 2426,
	"./thumbnail_prmintmayil1.jpg": 1928
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;